<template>
  <!-- 底部布局 -->
  <div class="bodys">
    <p class="top">版权所有:全国大学生智能汽车竞赛组织委员会秘书处</p>
    <!-- <p class="middle">联系地址:陕西省西安市咸宁西路28号 邮编:710049</p> -->
    <p class="top">备案号:湘ICP备2024087133号-1</p>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.bodys {
  background-color: #444444;
  height: 100%;
  width: 100%;
  padding: 5vh 0;
  p {
    color: white;
    font-size: 16px;
    display: block;
    line-height: 38px;
  }
}
</style>
